import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import NotificationPanelApp from "./Functionality/NotificationPanelApp";
import HeadTittle from "../../../../components/HeadTittle";
import routes from "../../../../Routes/routes";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import NotificationSectionTable from "./SubComponents/NotificationSectionTable";
import CustomExpandImage from "../../../../components/CustomExpandImage";
import DeleteCustomModal from "../UserDocPanel/Modal/DeleteCustomModal";

const NotificationPanel = () => {
    const {
        t,
        DEV,
        permission,
        contractorId,
        supplierId,
        modified,
        setModified,
        expandImage,
        setExpandImage,
        selectAnnouncementForDelete,
        setDeleteAnnouncementShow,
        isAllChecked,
        setIsAllChecked,
        deleteAnnouncementShow,
        setSlectAnnouncementForDelete,
        deleteAnnouncement,
    } = NotificationPanelApp();

    return (
        <>
            <HeadTittle name={'announcements'}>
                {(DEV || permission?.includes(permissionObj?.WEB_ANNOUNCEMENT_CREATE)) && (
                    <ButtonAction
                        id='btn_np_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        url={routes.announcement.create}
                    />
                )}
                {(contractorId || supplierId || DEV || permission?.includes(permissionObj?.WEB_ANNOUNCEMENT_DELETE)) && (
                    <ButtonAction
                        id='btn_np_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectAnnouncementForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => setDeleteAnnouncementShow(true)}
                    />
                )}
            </HeadTittle>
            <NotificationSectionTable
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                selectedList={selectAnnouncementForDelete}
                setSelectedList={setSlectAnnouncementForDelete}
                modified={modified}
                setModified={setModified}
                setExpandImage={setExpandImage}
            />

            <DeleteCustomModal
                show={deleteAnnouncementShow}
                onHide={() => setDeleteAnnouncementShow(false)}
                onConfirm={() => deleteAnnouncement(selectAnnouncementForDelete)}
                data={selectAnnouncementForDelete}
                title={t('delete_announcements')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('announcements')}
            />
            <CustomExpandImage expandImage={expandImage} setExpandImage={setExpandImage}/>
        </>
    );
};

export default NotificationPanel;
